import type { UpdateEventListDetail, UpdateEventSelectionDetail } from '../types';
import { invokeGet, removeAccents } from '../js-utils/_shared/form-utils';

interface Props {
    updateEvent?: string;
    apiOnChange?: string;
    childUpdateOnChange?: string;
    storeTextAsValue?: boolean;
}

export default function init(
    container: HTMLElement,
    { updateEvent, apiOnChange, childUpdateOnChange, storeTextAsValue }: Props,
) {
    // the parent container is the starting point
    const dropdown: HTMLElement = container.querySelector('select')!;
    const hiddenValue: HTMLInputElement | null = container.querySelector('.js2-value')!;

    async function callApiGet(id: string) {
        // call the API with a generic signature
        try {
            const response = await invokeGet(`${apiOnChange}?id=${id}`);
            if (response.data) {
                return response.data;
            }
        } catch (error) {}
        return null;
    }

    dropdown.addEventListener('change', (e: Event) => {
        const elem = e.currentTarget! as HTMLSelectElement;
        if (elem) {
            const index = elem.options.selectedIndex;
            const id = index < 0 ? '' : elem.options[index]?.value || '';
            if (hiddenValue) {
                hiddenValue.value = id;
                if (id && storeTextAsValue) {
                    hiddenValue.value = elem.options[index]?.textContent!.trim() || '';
                }
            }
            if (childUpdateOnChange) {
                // combined with apiOnChange: clear options, call API, send new options
                if (apiOnChange) {
                    // clear child options
                    document.dispatchEvent(
                        new CustomEvent<UpdateEventListDetail>(childUpdateOnChange, { detail: { options: [] } }),
                    );
                    if (id) {
                        callApiGet(id).then((data: any) => {
                            if (data) {
                                // build new child options
                                document.dispatchEvent(
                                    new CustomEvent<UpdateEventListDetail>(childUpdateOnChange, {
                                        detail: { options: data },
                                    }),
                                );
                            }
                        });
                    }
                } else {
                    // not combined with apiOnChange: dispatch an event with the option index and key - skip empty element
                    document.dispatchEvent(
                        new CustomEvent<UpdateEventSelectionDetail>(childUpdateOnChange, {
                            detail: { index: index - 1, key: id },
                        }),
                    );
                }
            }
        }
    });

    if (updateEvent) {
        document.addEventListener(updateEvent, function (event) {
            // remove all options except the first one
            const allItems: NodeListOf<HTMLElement> = dropdown.querySelectorAll('option');
            allItems.forEach((item: HTMLElement) => {
                if ((<HTMLOptionElement>item).value) {
                    item.remove();
                }
            });

            // receive and process the new set of options
            const customEvent = event as CustomEvent<UpdateEventListDetail>;
            const options: Array<{ id: string; nombre: string }> = customEvent.detail.options;

            if (options && options.length) {
                options.forEach((opt) => {
                    const elem = document.createElement('option');
                    elem.setAttribute('value', opt.id);
                    elem.innerHTML = opt.nombre;
                    dropdown.appendChild(elem);
                });
                container.style.visibility = 'visible';
            } else {
                container.style.visibility = 'hidden';
            }
        });
    }
}
